import { Component, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class AlertSecurityModalContext {
  public title: string;
  public secondaryBtn?: string;
  public primaryBtn?: string;
  public timer?: boolean;
  public customClass?: string;
  public customHTML?: string;
}

@Component({
  selector: 'app-alert-security-modal',
  templateUrl: './alert-security-modal.component.html'
})
export class AlertSecurityModalComponent {
  public context: any;
  public seconds: any = 0;
  public minutes: any = 0;
  public timeLeft = 300000; // 5 Minutes
  public interval: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialogRef<AlertSecurityModalContext>, private location: PlatformLocation) {
    location.onPopState(() => { this.beforeDismiss(); this.dialog.close(); });
    this.context = data;
    this.timer();
    this.refreshInterval();
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  beforeDismiss(): boolean {
    return this.beforeClose();
  }

  closeDialog(res?): void {
    this.beforeDismiss();
    this.dialog.close(res);
  }

  OK(): void {
    this.closeDialog(true);
  }
  cancel(): void {
    this.closeDialog('logout');
  }
  timer(): void {
    const totalSeconds = Math.floor(this.timeLeft / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    this.minutes = minutes < 10 ? '0' + minutes : minutes.toString();
    this.seconds = seconds < 10 ? '0' + seconds : seconds.toString();
  }
refreshInterval(): void {
  const endTime = Date.now() + this.timeLeft; // Calculate end time

  this.interval = setInterval(() => {
    this.timeLeft = endTime - Date.now(); // Calculate remaining time

    if (this.timeLeft > 0) {
      this.timer();
    } else {
      this.timeLeft = 0; // Ensure timeLeft is zero when time's up
      this.timer(); // Update display to show "00:00"
      this.closeDialog('logout');
      this.stopTimer(); // Clear the interval
      this.timeLeft = 300000; // Reset to 5 minutes
    }
  }, 1000);
}
  stopTimer() {
      clearInterval(this.interval);
  }
}
